const SchoolGraphic = () => {
  return (
    <section className="graphic-section graphic-section--school"></section>
  );
};

export default SchoolGraphic;
